import React, { createContext, FC, PropsWithChildren, useContext, useEffect, useState } from 'react'
import { useRouter } from 'next/router'

import type { EcboFeatureFlags } from 'lib/ecboFeatureFlags'
import { readEcboFeatureFlagsFromDocument } from 'lib/ecboFeatureFlags/browser'

const EcboFeatureFlagsContext = createContext<EcboFeatureFlags>({})
const EcboFeatureFlagsSyncedContext = createContext(false)

function readFlagsOnClient(): EcboFeatureFlags {
  if (typeof document === 'undefined') return {}
  return readEcboFeatureFlagsFromDocument()
}

export const EcboFeatureFlagsProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const router = useRouter()
  const [flags, setFlags] = useState<EcboFeatureFlags>(readFlagsOnClient)
  const [synced, setSynced] = useState(false)

  useEffect(() => {
    setFlags(readEcboFeatureFlagsFromDocument())
    setSynced(true)
  }, [router.asPath])

  return (
    <EcboFeatureFlagsSyncedContext.Provider value={synced}>
      <EcboFeatureFlagsContext.Provider value={flags}>{children}</EcboFeatureFlagsContext.Provider>
    </EcboFeatureFlagsSyncedContext.Provider>
  )
}

export function useEcboFeatureFlags(): EcboFeatureFlags {
  return useContext(EcboFeatureFlagsContext)
}

/**
 * Middleware が載せた ecbo_feature_flags を document.cookie から読み終えたか。
 * 初回 Search 前に true になるまで待つことで v1→v2 の二重リクエストを防ぐ。
 */
export function useEcboFeatureFlagsSynced(): boolean {
  return useContext(EcboFeatureFlagsSyncedContext)
}
